import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { FormattedMessage, injectIntl } from 'react-intl';

import { withEscHandler } from 'shared/hocs/modalWithEscHandler';
import { Button, Icon } from 'shared/components';

import theme from './CannotCreateOrUpdateAppointmentErrorModal.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  bodyValues: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
};

const CannotEditOngoingAppointmentErrorModal = ({ intl, onOk, bodyValues: { message, title } }) => (
  <React.Fragment>
    <div className={ theme.header }>
      <div>
        <FormattedMessage { ...title } />
      </div>
      <button onClick={ onOk } className={ theme.closingIconContainer } aria-label={ intl.formatMessage({ id: 'General.Cancel', defaultMessage: '** Cancel' }) }>
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.body }>
      <FormattedMessage { ...message } />
    </div>

    <div className={ theme.footer }>
      <Button
        testId="close-appointment-error-modal"
        label={ intl.formatMessage({
          id: 'General.Close',
          defaultMessage: '** Close',
        }) }
        onClick={ onOk }
        buttonType="naked"
        labelColor="blackMedium"
      />
    </div>
  </React.Fragment>
);

CannotEditOngoingAppointmentErrorModal.propTypes = propTypes;

export default compose(
  injectIntl,
  withEscHandler,
)(CannotEditOngoingAppointmentErrorModal);
